module.exports = __webpack_public_path__ + "img/app_brand_helix_technologies.97100d36.svg";